export default __webpack_public_path__ + "static/media/le_touquet3.62c52899.jpg";